import { Navigate } from "react-router-dom";
import { useClienteAuth } from "@/contexts/ClienteAuthContext";

export default function ClienteProtected({ children }) {
  const { cliente, loading } = useClienteAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F7FA] flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-[#0FB4B7] border-t-transparent rounded-full" />
      </div>
    );
  }
  if (!cliente) return <Navigate to="/cliente" replace />;
  return children;
}
